import { Link } from "react-router-dom";
import axios from "axios";
import config from "../../config/config";

import { toastSuccess } from "../../common/Toast";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import { useState } from "react";

const MarkInactive = ({ InactiveApiUrl, open, onClose }) => {
  // const [selectedRows,setSelectedRows] = useState(0)
  // console.log(rows,"rows")

  const token = localStorage.getItem("Token");
  const InactiveRequestParam = JSON.parse(
    localStorage.getItem("InactiveRequestParam")
  );
  console.log("InactiveRequestParam: ", InactiveRequestParam);
  const selectedRows = JSON.parse(
    localStorage.getItem("InactiveRequestParamlength")
  );
  console.log(selectedRows, "selectedRows");

  function handleDeletePopup() {
    // console.log("deleteApiUrl: ", deleteApiUrl);

    axios
      .post(
        `${InactiveApiUrl}`,
        {
          accountids: InactiveRequestParam,
          status: "DELETE",
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then(() => {
        toastSuccess(
          `${selectedRows == 0 ? 1 : selectedRows} accounts made inactive`
        );
        localStorage.removeItem("InactiveRequestParam");
        window.location.reload();
        onClose();
      });
  }

  return (
    <Dialog open={open}>
      <DialogTitle textAlign="center">Make accounts inactive</DialogTitle>
      <DialogContent>
        You're about to make {selectedRows} accounts inactive. This will remove
        them from the account and category fields on your transactions. You can
        make them active again later if you need to. Continue?
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button class="btn btn-sm btn-outline-dark" onClick={onClose}>
          Cancel
        </Button>
        <Button
          class="btn btn-sm btn-primary"
          onClick={handleDeletePopup}
          variant="contained"
        >
          Yes,make inactive
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MarkInactive;
